
































import { Component, Vue, Prop } from 'vue-property-decorator'

interface FAQType {
  question: string
  ans: string
  visible: boolean
  order: number
}

@Component({
  name: 'BlkFaq'
})
export default class extends Vue {
  @Prop({
    default: () => [
      {
        question:
          'Quais estruturas de distribuição a Balko possui? Como funciona cada uma delas?',
        ans: [
          'A depender da oportunidade disponível, o ativo será distribuído em uma estrutura diversa, que melhor atenda às especificidades das oportunidades.',
          'Modelo “True sale” – neste modelo de distribuição o usuário tem exposição direta ao ativo objeto da oportunidade. Através de um instrumento particular de cessão de crédito, a fração ideal do crédito é transferida ao novo proprietário.',
          'Modelo “Cédula de Crédito Bancário” (CCBs) – Uma sociedade, que possua o propósito específico de adquirir créditos, emite CCBs para dar cumprimento ao seu propósito e levantar o capital para isso. Com a aquisição do crédito, esse passa a ser a garantia da operação que conta com a proteção da regulamentação que cuida das CCBs.'
        ],
        visible: false,
        order: 7
      },
      {
        question: 'Quem pode investir?',
        ans: [
          'Podem investir pessoas físicas. No momento, não é possível o investimento por pessoas jurídicas.'
        ],
        visible: false,
        order: 6
      },
      {
        question: 'O ambiente de transação é seguro?',
        ans: [
          'O ambiente da transação para investimento é totalmente virtual e seguro. Os dados do investidor também são mantidos em ambiente seguro.'
        ],
        visible: false,
        order: 8
      },
      {
        question: 'Como funciona a tributação?',
        ans: [
          'A tributação sofre variação de acordo com o investimento realizado. A Balko, disponibiliza para seus investidores um Guia que auxilia na declaração do Imposto de Renda e é enviado anualmente. Dentre as possibilidade de tributação destacamos:',
          'Modelo “true sale”: A tributação incidente é o imposto de renda sobre o ganho de capital, regulado no artigo 21 da Lei nº 8.981/95. Em regra, a alíquota é de 15% e incidirá apenas sobre o valor do ganho de capital auferido pelo investidor na operação, deduzidos eventuais custos de transação. É importante verificar que há isenção do imposto de renda caso o valor total dos precatórios pagos ao investidor no mês do recebimento não exceda R$35.000,00.',
          'Modelo “Cédula de Crédito Bancário” (CCBs): Aqui a tributação aplicável é a relativa à Renda Fixa, com incidência da tabela regressiva.'
        ],
        visible: false,
        order: 5
      },
      {
        question: 'Quais os custos envolvidos?',
        ans: [
          'O investidor cria uma conta grátis e acessa as oportunidades de investimentos na plataforma, livre de cobranças. A taxa de distribuição dos ativos já está incluída na rentabilidade dos ativos.'
        ],
        visible: false,
        order: 4
      },
      {
        question:
          'Por que a rentabilidade das ofertas é substancialmente maior do que outros produtos financeiros?',
        ans: [
          'A Balko adquire ativos que possuem alta complexidade jurídica e baixa liquidez. Por conta disso, conseguimos negociar os ativos com deságio sobre o valor original. A combinação do deságio na compra mais os juros e correção do próprio título resultam na alta rentabilidade oferecida para nossos clientes.'
        ],
        visible: false,
        order: 3
      },
      {
        question: 'Qual o investimento mínimo?',
        ans: [
          'O investimento mínimo e máximo é definido em cada oferta, atingindo diferentes perfis de investimento.'
        ],
        visible: false,
        order: 2
      },
      {
        question: 'Quais os produtos oferecidos?',
        ans: [
          'São produtos oferecidos pela Balko: precatórios, direitos creditórios decorrentes de ações judiciais, créditos decorrentes de títulos não performados, dentre outros que fogem ao que está usualmente disponível às pessoas físicas em geral.'
        ],
        visible: false,
        order: 1
      },
      {
        question: 'O que é a Balko?',
        ans: [
          'A Balko é uma fintech brasileira nascida com o propósito de revolucionar o investimento em ativos alternativos. Através de um ambiente totalmente digital e seguro, oferecemos oportunidades de investimentos em ativos alternativos para o público em geral.'
        ],
        visible: false,
        order: 0
      }
    ]
  })
  faqs!: [FAQType]

  @Prop({ default: 8 }) showUpTo!: number

  get computedFAQS() {
    return this.faqs.sort((a, b) => a.order - b.order).slice(0, this.showUpTo)
  }
}
